/**
 * ORM(조직관리) 도메인 라우트 - 인사기본 > 조직 관리 메뉴.
 * route name = OBJECT_ID, 폴더=도메인=pages/orm. 조직도(ORM0002)·조직 개편/조직장/조직 히스토리(ORM0020·0030·0040).
 */
const ormRoutes = [
  {
    // 인사기본 > 조직관리 > 조직도 - AS-IS 오브젝트 ORM0002 (조직도). 트리=ORM0010_00_R01, 인원=ORM0040_01_R01.
    path: 'orm/org-chart',
    name: 'ORM0002',
    component: () => import('@/pages/orm/ORM0002.vue'),
    meta: { requiresAuth: true, title: '조직도', menuId: 'ORM0002', objInfo: '조직도 · ORM0002 (트리 ORM0010_00_R01)' },
  },
  {
    // 조직 개편 - 조회(기준일·진행 상태) + 개편안 그리드(8컬럼) + 툴바[조직 개편 시작·삭제·확정 취소·조직 확정] + 개편 그룹 생성 팝업 (인사기본 > 조직 관리)
    path: 'orm/org-restructure',
    name: 'ORM0020',
    component: () => import('@/pages/orm/ORM0020.vue'),
    meta: {
      requiresAuth: true,
      title: '조직 개편',
      menuId: 'ORM0020',
      objInfo: 'ORM0020 · 인사기본/조직 관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 조직장 관리 - 조회(조직·유형·등록현황·사원·지정권한) + 조직장/대리인 현황 그리드(9컬럼) + 지정 권한 변경·등록하기 드로어 (인사기본 > 조직 관리)
    path: 'orm/org-leader',
    name: 'ORM0030',
    component: () => import('@/pages/orm/ORM0030.vue'),
    meta: {
      requiresAuth: true,
      title: '조직장 관리',
      menuId: 'ORM0030',
      objInfo: 'ORM0030 · 인사기본/조직 관리 (미래모델·퍼블리싱)',
    },
  },
  {
    // 조직 히스토리 - 조회(기준일·보기방식·조직 유형) + 조직트리 + 조직 별 히스토리 그리드(9컬럼) (인사기본 > 조직 관리)
    path: 'orm/org-history',
    name: 'ORM0040',
    component: () => import('@/pages/orm/ORM0040.vue'),
    meta: {
      requiresAuth: true,
      title: '조직 히스토리',
      menuId: 'ORM0040',
      objInfo: 'ORM0040 · 인사기본/조직 관리 (미래모델·퍼블리싱)',
    },
  },
];

export default ormRoutes;
